<template>
  <a v-bind:target="target ? target : '_blank'"
     v-bind:href="url"
     class="button is-large is-outlined">
    <img v-if="leftIcon" :class="leftIcon" v-bind:src="this.$data[leftIcon + '_url']" />
    <p><slot>PROVIDE TEXT FOR THE BUTTON</slot></p>
    <img v-if="rightIcon" :class="rightIcon" v-bind:src="this.$data[rightIcon + '_url']" />
  </a>
</template>

<script>

export default {
  props: {
    url: {
      type: String,
      required: true
    },
    target: {
      type: String
    },
    leftIcon: {
      type: String
    },
    rightIcon: {
      type: String
    }
  },
  data () {
    return {
      calendar_url: "/assets/images/2021/success-page/calender_icon.svg",
      file_url: "/assets/images/2021/success-page/file_icon.svg",
      invoice_url: "/assets/images/2021/success-page/invoice_icon.svg",
      award_url: "/assets/images/2021/success-page/award_icon.svg",
      download_url: "/assets/images/2021/success-page/download_icon.svg",
      dashboard_url: "/assets/images/2021/success-page/dashboard_icon.svg",
      arrow_url: "/assets/images/2021/success-page/grey_arrow.svg",
      envelope_url: "/assets/images/2018/envelope-icon.svg",
    }
  }
}

</script>

<style scoped>
img {
  margin: 0 9px 0 9px;
}
p {
  border-bottom: 1px solid #000;
  font-size: 16px;
  margin-bottom: 5px;
  color: #041C2C;
}
</style>